import axios from 'axios'
import { api } from '../api'
import { toast } from 'react-toastify'
import { errorHandeller } from './Error'
//import 'react-toastify/dist/ReactToastify.css'
////toast.configure({ autoClose: 2000 })

// Index of items
const Index = async (header) => {
    try {
        const response = await axios.get(`${api}terms-and-conditions`, header)
        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        if (error) return errorHandeller(error)
    }
}

// Show specific item
const Show = async (id, header) => {
    try {
        const response = await axios.get(`${api}terms-and-conditions/${id}`, header)
        if (response.status === 200) {
            return response.data.terms
        }
    } catch (error) {
        if (error) return errorHandeller(error)
    }
}

// Store item
const Store = async (data, header) => {
    try {
        const response = await axios.post(`${api}terms-and-conditions`, data, header)
        if (response.status === 201) {
            toast.success(response.data.message)
            return true
        }
    } catch (error) {
        if (error) return errorHandeller(error)
    }
}

// Update specific item
const Update = async (id, data, header) => {
    try {
        const response = await axios.put(`${api}terms-and-conditions/${id}`, data, header)
        if (response.status === 201) {
            toast.success(response.data.message)
            return true
        }
    } catch (error) {
        if (error) return errorHandeller(error)
    }
}

// Delete item
const Delete = async (id, header) => {
    try {
        const response = await axios.delete(`${api}terms-and-conditions/${id}`, header)
        if (response.status === 200) {
            toast.success(response.data.message)
            return true
        }
    } catch (error) {
        if (error) return errorHandeller(error)
    }
}

const ContactUs = {
    Index,
    Show,
    Store,
    Update,
    Delete
}

export default ContactUs